import { render, staticRenderFns } from "./AuthorRank.vue?vue&type=template&id=335f81f3&scoped=true"
import script from "./AuthorRank.vue?vue&type=script&lang=js"
export * from "./AuthorRank.vue?vue&type=script&lang=js"
import style0 from "./AuthorRank.vue?vue&type=style&index=0&id=335f81f3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335f81f3",
  null
  
)

export default component.exports